export default {
    company_agency: "Magasin",
    document: "DNI",
    no_company_agency_found: "Aucun magasin trouvé",
    project_name: "Academia Alba",
}
